module.exports = __webpack_public_path__ + "img/334-fff4cd.png";